import React from 'react'
import { Button, Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'

export const BackButton = ({ url }) => {
  const pathGen = useGeneratePathI18n()

  return (
    <Button
      component={url === pathGen(ROUTES.MAIN) ? 'a' : Link}
      variant={'ghost'}
      noLabel
      grey
      startIcon={<Icon name={'back'} />}
      size={'s'}
      {...{ [url === pathGen(ROUTES.MAIN) ? 'href' : 'to']: url }}
    />
  )
}

BackButton.propTypes = {
  url: PropTypes.string,
}
